import contractAddressSvg from '@/assets/icons/contract_address.svg';

interface ContractAddressProps {
  className?: string;
}

export default function ContractAddress({ className = '' }: ContractAddressProps) {
  return (
    <img
      src={contractAddressSvg}
      alt="Contract Address"
      className={className}
    />
  );
}
